import { Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import { Subject, from, Observable, of } from 'rxjs';
import { Setting_Model, App_Config_Model } from './core.model';
import { LocalstorageService } from './Localstorage.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';

export const Config_key = 'KETT_SETTING';

@Injectable({ providedIn: 'root' })
export class CoreConfigService {
  private _X_KE_ID: string;

  public set X_KE_ID(val: string) {
    this._X_KE_ID = val;
  }
  public get X_KE_ID(): string {
    return this._X_KE_ID;
  }

  GetConfig(): Observable<any> {

    return this._HttpClient.get('assets/config.runtime.txt');
  }
  /**
   * api_path => backend_api
   * */
  private _base_config: App_Config_Model = {} as App_Config_Model;

  public set base_config(val: App_Config_Model) {
    this._base_config = val;
  }
  public get base_config(): App_Config_Model {
    return this._base_config;
  }

  constructor(
    private _HttpClient: HttpClient,
    @Inject(PLATFORM_ID) private platformId: any,
    private _injector: Injector
  ) {
    if (isPlatformBrowser(this.platformId)) {
      let _LocalstorageService = this._injector.get(LocalstorageService);
      let config = _LocalstorageService.getItem(Config_key);
      if (!config) {
        _LocalstorageService.setItem(Config_key, JSON.stringify(this.Setting));
        config = _LocalstorageService.getItem(Config_key);
      }
      this.Setting = JSON.parse(config);
    }
  }

  public set Setting(val) {
    this._Setting = val;
  }
  public get Setting() {
    return this._Setting;
  }

  private _Setting: Setting_Model = {
    lang: 'th',
  } as Setting_Model;

  public GetGUID() {
    let guid =
      this.s4() +
      this.s4() +
      '' +
      this.s4() +
      '' +
      this.s4() +
      '' +
      this.s4() +
      '' +
      this.s4() +
      this.s4() +
      this.s4();
    return guid;
  }

  private s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  public clientLifetime = new Subject();
  public HasUpdateCorporate = new Subject();
  public UpdateAuthentication = new Subject<boolean>();
  public ShowUDIDConfigByCustomerNo = new Subject<string>();
}
